import Logo from "assets/logo/logo.png";
import bg from "assets/air/air_support.png";
import air from "assets/common/support/air_icon.png";
import morning from "assets/common/support/morning_icon.png";
import quick from "assets/common/support/quick_icon.png";
import express from "assets/common/support/express_icon.png";
import phone from "assets/common/support/support_phone.png";
import fax from "assets/common/support/support_fax.png";
import email from "assets/common/support/support_email.png";
import { ilshinGroupPhone } from "hooks/utils/util";

export default function Tels() {
    return (
        <div className="flex-1 bg-[#f4f4f4] flex flex-col items-center pb-16 pt-5 responsive1200:pt-[0px] responsive1200:px-[4%]">
            <p className="py-[35px] text-[#333] text-[28px] font-[600] responsive1200:py-[30px] responsive1200:text-[24px]">
                일신그룹 고객센터
            </p>
            <div className="bg-white w-full max-w-[1200px] p-[50px] flex flex-col responsive1200:px-[4%] responsive1200:py-[10%]">
                <img src={Logo} alt="Logo" className="relative mx-auto animate-fade-in mb-[50px]" />

                <div className="grid grid-cols-3 border-t border-t-[#ddd] py-[30px] responsive1200:grid-cols-1 responsive1200:gap-[10px]">
                    <div className="flex items-center gap-[20px] justify-center responsive1200:justify-start responsive1200:max-w-[270px] responsive1200:w-full responsive1200:mx-auto">
                        <figure className="rounded-full bg-[#243a6f] w-[45px] h-[45px] flex justify-center items-center">
                            <img src={phone} alt="전화" />
                        </figure>
                        <div>
                            <p className="text-[#666666] responsive1200:text-[15px]">대표번호</p>
                            <strong className="text-[20px] font-[500] text-[#333333] responsive1200:text-[18px]">02-2661-4206</strong>
                        </div>
                    </div>
                    <div className="flex items-center gap-[20px] justify-center responsive1200:justify-start responsive1200:max-w-[270px] responsive1200:w-full responsive1200:mx-auto">
                        <figure className="rounded-full bg-[#243a6f] w-[45px] h-[45px] flex justify-center items-center">
                            <img src={fax} alt="팩스" />
                        </figure>
                        <div>
                            <p className="text-[#666666] responsive1200:text-[15px]">팩스번호</p>
                            <strong className="text-[20px] font-[500] text-[#333333] responsive1200:text-[18px]">031-971-4208</strong>
                        </div>
                    </div>
                    <div className="flex items-center gap-[20px] justify-center responsive1200:justify-start responsive1200:max-w-[270px] responsive1200:w-full responsive1200:mx-auto">
                        <figure className="rounded-full bg-[#243a6f] w-[45px] h-[45px] flex justify-center items-center">
                            <img src={email} alt="이메일" />
                        </figure>
                        <div>
                            <p className="text-[#666666] responsive1200:text-[15px]">이메일</p>
                            <strong className="text-[20px] font-[500] text-[#333333] responsive1200:text-[18px]">
                                ilshinair@ilshinair.com
                            </strong>
                        </div>
                    </div>
                </div>
                <div
                    className="relative bg-no-repeat bg-cover bg-center py-[60px] responsive1200:py-[50px] responsive1200:px-[5%]"
                    style={{ backgroundImage: `url(${bg})` }}
                >
                    <div className="text-white flex justify-center gap-[10%] items-center responsive1200:flex-col responsive1200:gap-[20px]">
                        <p className="text-[30px] font-[500] break-keep responsive1200:text-[28px] responsive1200:text-center">
                            Is Different! ILSHIN Different!
                        </p>
                        <div>
                            <p className="font-[500] text-[25px] break-keep responsive1200:text-center responsive1200:text-[18px] responsive1200:text-center">
                                목적지는 같아도 서비스는 다릅니다.
                            </p>
                            <p className="text-[17px] text-white/70 break-keep responsive1200:text-center responsive1200:text-[15px]">
                                이제 저렴하고, 빠르고, 정확한 저희 일신과 함께 하십시오
                            </p>
                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-2 gap-x-[40px] mt-[50px] responsive1200:grid-cols-1">
                    <div className="border-t border-t-[2px] border-t-[#243a6f] py-[50px] responsive1200:py-[20px]">
                        <div className="flex flex-col justify-center gap-[10px] items-center">
                            <figure className="w-[50px] h-[50px] flex items-center justify-center">
                                <img src={air} alt="" />
                            </figure>
                            <p className="text-[30px] text-[#333333] font-[700]">일신항공해운</p>
                            <p className="tracking-[0.22em] text-[#333333] font-[300] responsive1200:text-[14px]">
                                PREMIUM AIR&SEA SERVICE
                            </p>
                        </div>
                        <div className="bg-[#f8f8f8] flex items-center justify-center gap-[10px] py-[20px] mt-[40px] responsive1200:mt-[25px]">
                            <p className="text-[20px] text-[#333333] responsive1200:text-[18px]">고객센터</p>
                            <strong className="text-[35px] text-[#243a6f] responsive1200:text-[28px]">{ilshinGroupPhone("air")}</strong>
                        </div>
                    </div>
                    <div className="border-t border-t-[2px] border-t-[#243a6f] py-[50px] responsive1200:py-[20px]">
                        <div className="flex flex-col justify-center gap-[10px] items-center">
                            <figure className="w-[50px] h-[50px] flex items-center justify-center">
                                <img src={morning} alt="" />
                            </figure>
                            <p className="text-[30px] text-[#333333] font-[700]">일신모닝택배</p>
                            <p className="tracking-[0.22em] text-[#333333] font-[300] responsive1200:text-[14px]">
                                PREMIUM MORNING SERVICE
                            </p>
                        </div>
                        <div className="bg-[#f8f8f8] flex items-center justify-center gap-[10px] py-[20px] mt-[40px] responsive1200:mt-[25px]">
                            <p className="text-[20px] text-[#333333] responsive1200:text-[18px]">고객센터</p>
                            <strong className="text-[35px] text-[#243a6f] responsive1200:text-[28px]">{ilshinGroupPhone("morning")}</strong>
                        </div>
                    </div>
                    <div className="border-t border-t-[2px] border-t-[#243a6f] py-[50px] responsive1200:py-[20px]">
                        <div className="flex flex-col justify-center gap-[10px] items-center">
                            <figure className="w-[50px] h-[50px] flex items-center justify-center">
                                <img src={quick} alt="" />
                            </figure>
                            <p className="text-[30px] text-[#333333] font-[700]">일신모닝퀵</p>
                            <p className="tracking-[0.22em] text-[#333333] font-[300] responsive1200:text-[14px]">PREMIUM QUICK SERVICE</p>
                        </div>
                        <div className="bg-[#f8f8f8] flex items-center justify-center gap-[10px] py-[20px] mt-[40px] responsive1200:mt-[25px]">
                            <p className="text-[20px] text-[#333333] responsive1200:text-[18px]">고객센터</p>
                            <strong className="text-[35px] text-[#243a6f] responsive1200:text-[28px]">{ilshinGroupPhone("quick")}</strong>
                        </div>
                    </div>
                    <div className="border-t border-t-[2px] border-t-[#243a6f] py-[50px] responsive1200:py-[20px]">
                        <div className="flex flex-col justify-center gap-[10px] items-center">
                            <figure className="w-[50px] h-[50px] flex items-center justify-center">
                                <img src={express} alt="" />
                            </figure>
                            <p className="text-[30px] text-[#333333] font-[700]">일신특송화물</p>
                            <p className="tracking-[0.22em] text-[#333333] font-[300] responsive1200:text-[14px]">
                                PREMIUM EXPRESS SERVICE
                            </p>
                        </div>
                        <div className="bg-[#f8f8f8] flex items-center justify-center gap-[10px] py-[20px] mt-[40px] responsive1200:mt-[25px]">
                            <p className="text-[20px] text-[#333333] responsive1200:text-[18px]">고객센터</p>
                            <strong className="text-[35px] text-[#243a6f] responsive1200:text-[28px]">{ilshinGroupPhone("express")}</strong>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
